import './index.scss'
import Error from '../error'
import {CheckIcon, ErrorIcon, HelpIcon} from '../../../icons'
import InputInfo from '../inputInfo'
import {useEffect, useRef, useState} from 'react'
import classNames from 'classnames'
import useOnClickOutside from '../../../utils/hooks/useOutsideClick'
import {useSelector} from 'react-redux'

export const Input = ({
    customInput,
    type,
    minNumber,
    maxNumber,
    name,
    placeholder,
    value,
    onChange,
    onBlur,
    onFocus,
    defaultValue,
    innerRef,
    error,
    infoText,
    inputIsDisabled,
    activeInfo,
    handleInfo,
    onMouseOut,
    icon,
    isCheckedPass,
    hasRealTimeValidation,
    placeholderAsLabel = true,
    isValid = true,
    inputClassName,
    pinnedPart,
    customIcon,
    customIconOnclick,
    isReadonly = false,
    containerClassName
}) => {
    const [helpInfoIsActive, setHelpInfoIsActive] = useState(activeInfo)
    const [hasValue, setHasValue] = useState(false)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const ref = useRef(null)
    const infoRef = useRef()
    useOnClickOutside(infoRef, () => setHelpInfoIsActive(false))

    const setHelpInfoStatus = () => {
        setHelpInfoIsActive(!helpInfoIsActive)
        typeof handleInfo === 'function' && handleInfo(!helpInfoIsActive)
    }

    const placeholderClassName = (hasValue && placeholder) ? 'has-value' : 'empty'

    const updateLabelVisibility = () => {
        if (placeholderAsLabel) {
            const inputText = ref?.current?.value
            const condition = inputText?.length
            setHasValue(condition)
        }
    }

    const handleOnFocus = e => {
        if (isReadonly) {
            e.preventDefault()
            e.target.blur()
            return
        }
        onFocus?.()
    }

    useEffect(() => {
        setHelpInfoIsActive(activeInfo)
    }, [activeInfo])

    useEffect(() => {
        updateLabelVisibility()
    }, [value])

    return (
        <div className={classNames('form-element', {
            [containerClassName]: !!containerClassName
        })}>
            <div className={classNames('input', {
                'dark': isDarkMode})}>
                {customInput || (
                    <input onChange={onChange} value={value} onBlur={onBlur} onFocus={e => handleOnFocus(e)}
                        className={classNames('simple-input', {[placeholderClassName]: placeholderAsLabel, 'error' : error, 'border-red' : !isValid, 'pass': icon, 'not-pass': isCheckedPass && !icon, [inputClassName]: inputClassName, 'dark': isDarkMode})}
                        onMouseOut={onMouseOut}
                        type={type}
                        name={name} id={name}
                        onInput={updateLabelVisibility}
                        placeholder={!placeholderAsLabel ? placeholder : undefined}
                        ref={placeholderAsLabel ? ref : innerRef}
                        defaultValue={defaultValue}
                        disabled={inputIsDisabled}
                        readOnly={isReadonly}
                        min={type === 'number' && minNumber}
                        max={type === 'number' && maxNumber}/>
                )}
                {pinnedPart && (
                    <div className="pinned">
                        <span>{pinnedPart}</span>
                    </div>
                )}
                {placeholderAsLabel && (
                    <span className={classNames({
                        'input-placeholder': true,
                        [placeholderClassName]: placeholderClassName
                    })}>{placeholder}</span>
                )}
                {infoText && (
                    <div ref={infoRef} className={`help ${helpInfoIsActive ? 'active' : ''}`} onClick={setHelpInfoStatus}>
                        <span><HelpIcon/></span>
                        <InputInfo text={infoText}/>
                    </div>
                )}
                {customIcon && (
                    <div className="help" onClick={customIconOnclick}>
                        <span>{customIcon}</span>
                    </div>
                )}
                {icon && <span className="check-icon">
                    <CheckIcon/>
                </span>
                }
                {error && hasRealTimeValidation && (
                    <span className="check-icon">
                        <ErrorIcon/>
                    </span>
                )}
            </div>
            {error && <Error error={error}/>}
        </div>
    )
}

export default Input
